import React from 'react';
import {
  Box, VStack, Icon, Heading, Text,
} from '@gluestack-ui/themed';
import { Save } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

interface SaveRequiredPlaceholderProps {
  typeName: string;
}

const SaveRequiredPlaceholder: React.FC<SaveRequiredPlaceholderProps> = ({ typeName }) => {
  const { t } = useTranslation();

  return (
    <Box flex={1} bg="$bgApp" justifyContent="center" alignItems="center" p="$6">
      <VStack space="md" alignItems="center" maxWidth={400}>
        <Box bg="$bgSubtle" p="$4" borderRadius="$full">
          <Icon as={Save} size="xl" color="$brandBase" />
        </Box>
        <Heading size="md" textAlign="center">
          {t('lecturer.moduleEditor.taskEditor.saveRequired.title', 'Save Required')}
        </Heading>
        <Text textAlign="center" color="$textSubtle">
          {t(
            'lecturer.moduleEditor.taskEditor.saveRequired.message',
            {
              defaultValue: `You have changed the task type to ${typeName}. Please save your changes before configuring specific settings.`,
              type: typeName,
            },
          )}
        </Text>
      </VStack>
    </Box>
  );
};

export default SaveRequiredPlaceholder;
